import { observer } from 'mobx-react-lite'
import { Navigate, useLoaderData } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import logoUrl from '@/assets/misc/img_taxfyle-symbol.svg'
import { useRootStore } from '@/contexts/root-store-context'
import { useTask } from '@/hooks/task-hooks'
import { LandingPageView } from './index'
import { useDocumentTitle } from '@/hooks/document-title'
import { useLightDarkFn } from '@/features/shell/theming/color-scheme-hooks'

export default observer(function LandingPageViewContainer() {
  useDocumentTitle('Welcome')
  const lightDark = useLightDarkFn()
  const redirectUrl = useLoaderData<string | null>()
  const [searchParams] = useSearchParams()
  const {
    iam: { authStore, readPreselectedWorkspaceInfo },
  } = useRootStore()

  const workspaceInfo = readPreselectedWorkspaceInfo()

  const login = useTask.resolved(
    () =>
      authStore.login({
        returnUrl: searchParams.get('returnUrl'),
      }),
    [authStore, searchParams],
  )
  const signup = useTask.resolved(
    () =>
      authStore.signup({
        returnUrl: searchParams.get('returnUrl'),
      }),
    [authStore, searchParams],
  )

  const isPending = login.pending || signup.pending

  if (typeof redirectUrl === 'string') {
    return <Navigate replace to={redirectUrl} />
  }

  const effectiveIconUrl = lightDark(
    workspaceInfo?.iconUrl,
    workspaceInfo?.invertedIconUrl,
  )

  return (
    <LandingPageView
      logoUrl={effectiveIconUrl || logoUrl}
      logoAlt={`${workspaceInfo?.name || 'Taxfyle'} logo`}
      isPending={isPending}
      onLogin={login}
      onSignup={signup}
      testId="landing-page"
      createAccountButtonTestId="create-account-button"
      signInButtonTestId="sign-in-button"
    />
  )
})
